import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { add, getList, getRole, getRoleTree, grant, grantTree, remove, update } from "@/api/system/role";
import { mapGetters } from "vuex";
import website from '@/config/website';
export default {
  data: function data() {
    return {
      form: {},
      box: false,
      props: {
        label: "title",
        value: "key"
      },
      menuGrantList: [],
      dataScopeGrantList: [],
      apiScopeGrantList: [],
      apiGrantList: [],
      menuTreeObj: [],
      dataScopeTreeObj: [],
      apiScopeTreeObj: [],
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        tip: false,
        simplePage: true,
        searchShow: true,
        searchMenuSpan: 6,
        tree: true,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogWidth: 900,
        dialogClickModal: false,
        column: [{
          label: "角色名称",
          prop: "roleName",
          search: true,
          span: 24,
          rules: [{
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          }]
        }, {
          label: "所属租户",
          prop: "tenantId",
          type: "tree",
          dicUrl: "/api/blade-system/tenant/select",
          addDisplay: false,
          editDisplay: false,
          viewDisplay: website.tenantMode,
          span: 24,
          props: {
            label: "tenantName",
            value: "tenantId"
          },
          hide: !website.tenantMode,
          search: website.tenantMode,
          rules: [{
            required: true,
            message: "请输入所属租户",
            trigger: "click"
          }]
        }, {
          label: "角色别名",
          prop: "roleAlias",
          search: true,
          span: 24,
          rules: [{
            required: true,
            message: "请输入角色别名",
            trigger: "blur"
          }]
        }, {
          label: "上级角色",
          prop: "parentId",
          dicData: [],
          type: "tree",
          hide: true,
          span: 24,
          props: {
            label: "title"
          },
          rules: [{
            required: false,
            message: "请选择上级角色",
            trigger: "click"
          }]
        }, {
          label: "角色排序",
          prop: "sort",
          type: "number",
          span: 24,
          rules: [{
            required: true,
            message: "请输入角色排序",
            trigger: "blur"
          }]
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userInfo", "permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.role_add, false),
        viewBtn: this.vaildData(this.permission.role_view, false),
        delBtn: this.vaildData(this.permission.role_delete, false),
        editBtn: this.vaildData(this.permission.role_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
    idsArray: function idsArray() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids;
    }
  }),
  methods: {
    initData: function initData() {
      var _this = this;

      getRoleTree().then(function (res) {
        var column = _this.findObject(_this.option.column, "parentId");

        column.dicData = res.data.data;
      });
    },
    submit: function submit() {
      var _this2 = this;

      var menuList = this.$refs.treeMenu.getCheckedKeys();
      var dataScopeList = this.$refs.treeDataScope.getCheckedKeys();
      var apiScopeList = this.$refs.treeApiScope.getCheckedKeys();
      grant(this.idsArray, menuList, dataScopeList, apiScopeList).then(function () {
        _this2.box = false;

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        _this2.onLoad(_this2.page);
      });
    },
    rowSave: function rowSave(row, done, loading) {
      var _this3 = this;

      add(row).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this4 = this;

      update(row).then(function () {
        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this5 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    beforeOpen: function beforeOpen(done, type) {
      if (["add", "edit"].includes(type)) {
        this.initData();
      }

      done();
    },
    handleRole: function handleRole() {
      var _this6 = this;

      if (this.selectionList.length !== 1) {
        this.$message.warning("只能选择一条数据");
        return;
      }

      this.menuTreeObj = [];
      this.dataScopeTreeObj = [];
      this.apiScopeTreeObj = [];
      grantTree().then(function (res) {
        _this6.menuGrantList = res.data.data.menu;
        _this6.dataScopeGrantList = res.data.data.dataScope;
        _this6.apiScopeGrantList = res.data.data.apiScope;
        getRole(_this6.ids).then(function (res) {
          _this6.menuTreeObj = res.data.data.menu;
          _this6.dataScopeTreeObj = res.data.data.dataScope;
          _this6.apiScopeTreeObj = res.data.data.apiScope;
          _this6.box = true;
        });
      });
    },
    handleDelete: function handleDelete() {
      var _this7 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this7.ids);
      }).then(function () {
        _this7.onLoad(_this7.page);

        _this7.$message({
          type: "success",
          message: "操作成功!"
        });

        _this7.$refs.crud.toggleSelection();
      });
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this8 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(function (res) {
        _this8.data = res.data.data;
        _this8.loading = false;

        _this8.selectionClear();
      });
    }
  }
};